import { render, staticRenderFns } from "./applyMsgMng.vue?vue&type=template&id=f8007590&scoped=true"
import script from "./applyMsgMng.vue?vue&type=script&lang=js"
export * from "./applyMsgMng.vue?vue&type=script&lang=js"
import style0 from "./applyMsgMng.vue?vue&type=style&index=0&id=f8007590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8007590",
  null
  
)

export default component.exports